import { t } from '../../utils/i18n';
import { SCREEN } from '../../utils/constants';
import {
    appUrl,
    form,
    locations,
    selectedCodeNumber,
    selectedCountry,
} from '../../utils/variables';
import { loadCountriesCodeDropdown } from '../components/countries';
import { LocationDropdown } from '../components/locationSelect';

export function loadAskQuestionComponents() {
    document
        .querySelector('.askQuestion__container .phone__selected-code img')
        .setAttribute(
            'src',
            `${appUrl}/assets/images/svg/${selectedCountry.toLowerCase()}.svg`
        );

    document.querySelector(
        '.askQuestion__container .selected-country-code'
    ).innerHTML = '+' + selectedCodeNumber;

    document.querySelector(
        '.askQuestion__container .phone__countryCode--select'
    ).innerHTML = loadCountriesCodeDropdown(SCREEN.ASK_QUESTION);

    // load dropdown select location
    new LocationDropdown({ locations: locations });

    // lead source dropdown
    const leadSourceOptions = Array.isArray(form?.appointment_channel?.lead_source_options)
        ? form.appointment_channel.lead_source_options
        : [];
    const wrapper = document.querySelector('.lead-source-ask-question__wrapper');
    if (wrapper) {
        wrapper.innerHTML = '';
        if (leadSourceOptions.length > 0) {
            const optVal = (o) => (typeof o === 'string' ? o : (o?.value ?? o?.label ?? String(o)));
            const optLabel = (o) => (typeof o === 'string' ? o : (o?.label ?? o?.value ?? String(o)));
            wrapper.innerHTML = `
                <div data-form="sourceAskQuestion" class="form-control">
                    <select id="sourceAskQuestion" name="source" aria-label="${t('how_did_you_hear')}">
                        <option value="" disabled selected>${t('how_did_you_hear')}</option>
                        ${leadSourceOptions.map((o) => `<option value="${optVal(o)}">${optLabel(o)}</option>`).join('')}
                    </select>
                </div>
            `;
        }
    }
}
